export default __webpack_public_path__ + "static/media/4540.df433321.png";